/*
 * The apps tab for QBO integration mappings of app to vendor.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
// import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import TabPageTitle from '../ui/TabPageTitle';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Input, NativeSelect, Table, TableHead, TableBody, TableRow, TableCell, Typography } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';

const abEnvironment = new AbEnvironment();
const QBOIntegrationAppsQuery = graphql`
query QBOIntegrationAppsQuery($accountId: UUID!, $searchParm: String!, $first: Int) {
  appsearchconfiguredbyappname(accountid: $accountId, search: $searchParm, first: $first) {
    totalCount
    nodes {
        appId
        accountId
        appStatus
        appName
        appSku
        appUrl
        appLogo
        description
        appType
    }  
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  appDiv: {
    marginTop: 0
  }
});

class QBOIntegrationApps extends Component {
  state = {
    searchP: '',
    appVendorMaps: [],  // Changed app vendor mappings
    costMaps: [],       // Changed COGS mappings
    expenseMaps: [],    // Changed expense mappings
    revenueMaps: []     // Changed revenue mappings
  };

  componentDidMount() {
    // Is there something in local storage?
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  /**
   * Get a node for use in displaying a dropdown value.
   * 
   * @param {*} mapName 
   * @param {*} appId 
   * @returns 
   */
  getAppMapNode(mapName, appId) {
    let theStateMap;
    let thePropsMap;

    if (mapName === 'AppVendor') {
      theStateMap = this.state.appVendorMaps;
      thePropsMap = this.props.appVendorMaps;
    } else if (mapName === 'SubscriptionCost') {
      theStateMap = this.state.costMaps;
      thePropsMap = this.props.costMaps;
    } else if (mapName === 'SubscriptionExpense') {
      theStateMap = this.state.expenseMaps;
      thePropsMap = this.props.expenseMaps;
    } else if (mapName === 'SubscriptionRevenue') {
      theStateMap = this.state.revenueMaps;
      thePropsMap = this.props.revenueMaps;
    }

    let theMapNode = {
      accountDelegatedAuthsMapId: null,
      appId: appId,
      entityId: '',
      entityDescription: ''
    };

    for (let i=0; i<theStateMap.length; i++) {
      if (theStateMap[i].appId === appId) {
        theMapNode.accountDelegatedAuthsMapId = theStateMap[i].accountDelegatedAuthsMapId;
        theMapNode.entityId = theStateMap[i].entityId;
        theMapNode.entityDescription = theStateMap[i].entityDescription;
        return theMapNode;
      }
    }

    for (let i = 0; i < thePropsMap.length; i++) {
      let theIdx = thePropsMap[i].mapName.indexOf(':');
      let theMappedAppId = thePropsMap[i].mapName.substring(theIdx + 1);
      if (theMappedAppId === appId) {
        // We have a match
        theMapNode.accountDelegatedAuthsMapId = thePropsMap[i].accountDelegatedAuthsMapId;
        theMapNode.entityId = thePropsMap[i].entityId;
        theMapNode.entityDescription = thePropsMap[i].entityDescription;
        break;
      }
    }

    // Finally, set a default (so we have something instead of "select")
    if (theMapNode.entityId === '' && mapName !== 'AppVendor') {
      for (let i=0; i<thePropsMap.length; i++) {
        if (thePropsMap[i].mapName === mapName) {
          theMapNode.entityId = thePropsMap[i].entityId;
          theMapNode.entityDescription = thePropsMap[i].entityDescription;
          break;
        }
      }
    }

    return theMapNode;
  }

  updateAppMapNode(mapName, appId, accountDelegatedAuthId, entityId) {
    // alert('update called with map ' + mapName + ' entityId ' + entityId);
    let theNode = {
      accountDelegatedAuthsMapId: accountDelegatedAuthId,
      mapName: mapName,
      appId: appId,
      entityId: entityId,
      entityDescription: '',
    }

    if (mapName === "AppVendor") {
      theNode.entityName = "Vendor";

      // Lookup the name from the QBO list
      for (let i = 0; i < this.props.qboVendors.length; i++) {
        if (this.props.qboVendors[i].Id === entityId) {
          theNode.entityDescription = this.props.qboVendors[i].DisplayName;
          break;
        }
      }

      // Is this in state already?
      let theMap = this.state.appVendorMaps;
      let found = false;
      for (let i = 0; i < theMap.length; i++) {
        if (theMap[i].appId === appId) {
          theMap[i].entityId = entityId;
          theMap[i].entityDescription = theNode.entityDescription;
          found = true;
          break;
        }
      }
      if (!found) {
        theMap.push(theNode);
      }
      this.setState({ appVendorMaps: theMap });
    } else if (mapName === "SubscriptionExpense") {
      theNode.entityName = "Account";

      // Lookup the name from the QBO list
      for (let i = 0; i < this.props.qboAccountsExpense.length; i++) {
        if (this.props.qboAccountsExpense[i].Id === entityId) {
          theNode.entityDescription = this.props.qboAccountsExpense[i].Name;
          break;
        }
      }

      // Is this in state already?
      let theMap = this.state.expenseMaps;
      let found = false;
      for (let i = 0; i < theMap.length; i++) {
        if (theMap[i].appId === appId) {
          theMap[i].entityId = entityId;
          theMap[i].entityDescription = theNode.entityDescription;
          found = true;
          break;
        }
      }
      if (!found) {
        theMap.push(theNode);
      }
      this.setState({ expenseMaps: theMap });
    } else if (mapName === "SubscriptionCost") {
      theNode.entityName = "Account";

      // Lookup the name from the QBO list
      for (let i = 0; i < this.props.qboAccountsCogs.length; i++) {
        if (this.props.qboAccountsCogs[i].Id === entityId) {
          theNode.entityDescription = this.props.qboAccountsCogs[i].Name;
          break;
        }
      }

      // Is this in state already?
      let theMap = this.state.costMaps;
      let found = false;
      for (let i = 0; i < theMap.length; i++) {
        if (theMap[i].appId === appId) {
          theMap[i].entityId = entityId;
          theMap[i].entityDescription = theNode.entityDescription;
          found = true;
          break;
        }
      }
      if (!found) {
        theMap.push(theNode);
      }
      this.setState({ costMaps: theMap });
    } else if (mapName === "SubscriptionRevenue") {
      theNode.entityName = "Account";

      // Lookup the name from the QBO list
      for (let i = 0; i < this.props.qboAccountsRevenue.length; i++) {
        if (this.props.qboAccountsRevenue[i].Id === entityId) {
          theNode.entityDescription = this.props.qboAccountsRevenue[i].Name;
          break;
        }
      }

      // Is this in state already?
      let theMap = this.state.revenueMaps;
      let found = false;
      for (let i = 0; i < theMap.length; i++) {
        if (theMap[i].appId === appId) {
          theMap[i].entityId = entityId;
          theMap[i].entityDescription = theNode.entityDescription;
          found = true;
          break;
        }
      }
      if (!found) {
        theMap.push(theNode);
      }
      this.setState({ revenueMaps: theMap });
    }  
  }

  isSaveDisabled() {
    if (this.state.appVendorMaps.length > 0) {
      return false;
    }
    if (this.state.costMaps.length > 0) {
      return false;
    }
    if (this.state.expenseMaps.length > 0) {
      return false;
    }
    if (this.state.revenueMaps.length > 0) {
      return false;
    }
    return true;
  }

  clearChanges() {
    this.setState({appVendorMaps: [], costMaps: [], expenseMaps: [], revenueMaps: []});
  }

  saveSettings() {
    // Call api to persist state changes to the db, then force a parent refresh.
    const { callPartnerApi } = this.props.auth;

    let combinedMaps = [];
    combinedMaps = combinedMaps.concat(this.state.appVendorMaps, this.state.costMaps, this.state.expenseMaps, this.state.revenueMaps);
    // console.log('saveSettings called, sending maps: ' + JSON.stringify(combinedMaps));

    // If parms are non-null, we have mappings.
    let payload = {
      operation: "QBOUpdateAppMappings",
      params: {
        accountDelegatedAuthsId:  this.props.adaId,
        maps: combinedMaps
      }
    };

    Promise.resolve()
    .then(() => { 
        return callPartnerApi('appbind/generic',
                              'POST',
                              payload);
    })
    .then(response => {
        return response.json();
    })
    .then(data => {
      this.props.forceParentQuery();
    })
    .catch(error => {
      this.props.forceParentQuery();
    });
  }
  
  render() {
    const { logError } = this.props.auth;
    const classes = this.props.classes;

    let numberToShow = 50;

    let accountId = abEnvironment.getUserAttribute('a_id');

    // Prep the list of QBO vendors
    let qboVendors = [];
    if (this.props.qboVendors != null && this.props.qboVendors.length > 0) {
      qboVendors = this.props.qboVendors;
    }

    // Prep the list of expense accounts
    let qboAccountsExpense = [];
    if (this.props.qboAccountsExpense != null && this.props.qboAccountsExpense.length > 0) {
      qboAccountsExpense = this.props.qboAccountsExpense;
    }

    // Prep the list of cogs accounts
    let qboAccountsCogs = [];
    if (this.props.qboAccountsCogs != null && this.props.qboAccountsCogs.length > 0) {
      qboAccountsCogs = this.props.qboAccountsCogs;
    }

    // Prep the list of revenue accounts
    let qboAccountsRevenue = [];
    if (this.props.qboAccountsRevenue != null && this.props.qboAccountsRevenue.length > 0) {
      qboAccountsRevenue = this.props.qboAccountsRevenue;
    }

    return (
      <Grid container spacing={1} direction="row" justifyContent="flex-start">
        <Grid item xs={12}>
          <TabPageTitle title="Vendor mappings" subtitle="Apps can be mapped to vendors in QBO.  You can also override the accounts that charges are attached to for specific apps."/>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <SearchField
                id="searchP"
                label="Search by name"
                value={this.state.searchP}
                onChange={this.handleChange('searchP')}
              />
            </Grid>
            <Grid item>
              <Grid container spacing={1} direction="row" justifyContent="flex-start">
                <Grid item>
                  <Button color="primary" 
                          variant="outlined" 
                          disabled={this.isSaveDisabled()} 
                          onClick={()=> { this.clearChanges() }}>
                    Undo unsaved changes
                  </Button>
                </Grid>
                <Grid item>
                  <Button color="primary" 
                          variant="contained" 
                          disabled={this.isSaveDisabled()} 
                          onClick={()=> { this.saveSettings() }}>
                    Save mappings
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}> 
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={QBOIntegrationAppsQuery}
            variables={{accountId: accountId, searchParm: this.state.searchP, first: numberToShow}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                let appCount = props.appsearchconfiguredbyappname.totalCount;
                let appNodes = props.appsearchconfiguredbyappname.nodes;

                let rowCount = 0;

                return (
                  <Grid container spacing={1} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      {this.state.searchP.length === 0 && appCount === 0 &&
                      <Typography>You haven't purchased or set up any apps yet</Typography>}
                      {this.state.searchP.length > 0 && appCount === 0 && 
                      <Typography>No matching apps</Typography>}
                      {this.state.searchP.length === 0 && appCount === 1 &&
                      <Typography>1 app</Typography>}
                      {this.state.searchP.length > 0 && appCount === 1 &&
                      <Typography>1 matching app</Typography>}
                      {this.state.searchP.length === 0 && appCount > 1 &&
                      <Typography>{appCount} apps</Typography>}
                      {this.state.searchP.length > 0 && props.appsearchconfiguredbyappname.totalCount > 1 &&
                      <Typography>{appCount} matching apps</Typography>}
                    </Grid>
                    <Grid item xs={12}>
                      <Table>
                        <TableHead style={AppBindStyles.tableHead}>
                          <TableRow style={AppBindStyles.tableHeadRow}>
                            <TableCell>App</TableCell>
                            <TableCell>QBO vendor</TableCell>
                            <TableCell>Expense account</TableCell>
                            <TableCell>COGS account</TableCell>
                            <TableCell>Revenue account</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {appNodes.map(n => {
                            rowCount++;

                            let vendorId = "vendor_" + rowCount;
                            let theVendor = this.getAppMapNode('AppVendor', n.appId);
                            // console.log('theVendor: ' + JSON.stringify(theVendor));

                            let expenseId = "expense_" + rowCount;
                            let theExpenseAccount = this.getAppMapNode('SubscriptionExpense', n.appId);
                            // console.log('theExpenseAccount: ' + JSON.stringify(theExpenseAccount));

                            let cogsId = "cogs_" + rowCount;
                            let theCogsAccount = this.getAppMapNode('SubscriptionCost', n.appId);
                            // console.log('theCogsAccount: ' + JSON.stringify(theCogsAccount));

                            let revenueId = "revenue_" + rowCount;
                            let theRevenueAccount = this.getAppMapNode('SubscriptionRevenue', n.appId);
                            // console.log('theRevenueAccount: ' + JSON.stringify(theRevenueAccount));

                            return (
                              <TableRow key={n.appId} style={AppBindStyles.tableRow}>
                                <TableCell>{n.appName}</TableCell>
                                <TableCell>
                                  <NativeSelect
                                    value={theVendor.entityId}
                                    input={<Input name={vendorId} id={vendorId} />}
                                      onChange={(e) => this.updateAppMapNode('AppVendor', n.appId, theVendor.accountDelegatedAuthsMapId, e.target.value) }
                                    >
                                    {qboVendors.map(v => {
                                      return(<option key={v.Id} value={v.Id}>{v.DisplayName}</option>);
                                    })}
                                    <option key="" value="">Not mapped</option>
                                  </NativeSelect>                                
                                </TableCell>
                                
                                <TableCell>
                                  <NativeSelect
                                    value={theExpenseAccount.entityId}
                                    input={<Input name={expenseId} id={expenseId} />}
                                      onChange={(e) => this.updateAppMapNode('SubscriptionExpense', n.appId, theExpenseAccount.accountDelegatedAuthsMapId, e.target.value) }
                                    >
                                    {qboAccountsExpense.map(v => {
                                      return(<option key={v.Id} value={v.Id}>{v.Name}</option>);
                                    })}
                                  </NativeSelect>                                
                                </TableCell>
                                <TableCell>
                                  <NativeSelect
                                    value={theCogsAccount.entityId}
                                    input={<Input name={cogsId} id={cogsId} />}
                                      onChange={(e) => this.updateAppMapNode('SubscriptionCost', n.appId, theCogsAccount.accountDelegatedAuthsMapId, e.target.value) }
                                    >
                                    {qboAccountsCogs.map(v => {
                                      return(<option key={v.Id} value={v.Id}>{v.Name}</option>);
                                    })}
                                  </NativeSelect>                                
                                </TableCell>
                                <TableCell>
                                  <NativeSelect
                                    value={theRevenueAccount.entityId}
                                    input={<Input name={revenueId} id={revenueId} />}
                                      onChange={(e) => this.updateAppMapNode('SubscriptionRevenue', n.appId, theRevenueAccount.accountDelegatedAuthsMapId, e.target.value) }
                                    >
                                    {qboAccountsRevenue.map(v => {
                                      return(<option key={v.Id} value={v.Id}>{v.Name}</option>);
                                    })}
                                  </NativeSelect>                                
                                </TableCell>
                              </TableRow>
                            );
                          })}

                        </TableBody>
                      </Table>
                    </Grid>
                  </Grid>      
                )
              }
              return (
                <div className={classes.appDiv}>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </Grid>
      </Grid>
    );
  }

}

export default withStyles(styleSheet)(QBOIntegrationApps);
